import { Box, TableCell, Typography } from "@mui/material";
import { GetSDEnum } from "./getSDEnum";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";

export const C5Cells = ({ controller }) => {
  return (
    <>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>{controller.controller}</TableCell>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>{controller.numPlungers}</TableCell>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>{controller.value}</TableCell>
      <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
        {controller.value === 0 ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: 14 }}>Normal Operation ✅</Typography>
            {/* <CheckCircleIcon sx={{ color: "success.main" }} /> */}
          </Box>
        ) : controller.value === -1 ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: 14 }}>MODBUS ⚠️</Typography>
            {/* <WarningIcon sx={{ color: "warning.main" }} /> */}
          </Box>
        ) : controller.value > 0 ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <GetSDEnum controller={controller} type={"C5"} icon={"⛔"} />
            {/* <ErrorIcon sx={{ color: "error.main" }} /> */}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: 2,
            }}
          >
            <GetSDEnum controller={controller} type={"C5"} icon={"✅"} />
            {/* <CheckCircleIcon sx={{ color: "success.main" }} /> */}
          </Box>
        )}
      </TableCell>
    </>
  );
};
